import React, { Component } from 'react';
import { connect } from "react-redux";


import {toast} from "react-toastify";
import {widgetCode} from "../../lib/helper";
import API from "../../lib/api";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Installation extends Component {

    constructor(props) {
        super(props);
        this.state={
            loader: false,
        }
        this.completeSetup=this.completeSetup.bind(this);
    }
    copyCodeToClipboard = () => {
        const el = this.textArea
        el.select()
        document.execCommand("copy");
        toast.success("Code copied");
    }
    completeSetup(){
        this.setState({
            loader:true
        });
        var _that=this;
        var formData = new FormData();
        API.post("completed_setup", formData).then((response) => {

            if (response.status === 200) {
                _that.setState({
                    loader:false
                });
                if (response.data.message.status == false) {
                    if (typeof response.data.message.error !== "undefined") {
                        $.each(response.data.message.error, function (k, v) {
                            toast.error(v);
                        });
                        return false;
                    }
                } else if (response.data.message.status == true) {
                    if (typeof response.data.message.success !== "undefined") {
                        window.location.reload();
                        return false;
                    }
                }
            }
        });
    }

    render() {
        const { t } = this.props;
        return (

            <div className="container installation">
                <div className="row justify-content-center mt-0">
                    <div className="col-100  col-lg-60 text-center  mt-3 mb-2">
                        <div className="card px-0 pt-4 pb-4 mt-3 mb-3">
                            <h2 className="activation_title"><strong>Install Chat on Your Site</strong></h2>

                            <div className="container">
                                <div className="row">
                                    <div className="col-md-100 mx-0">
                                        <div id="msform">

                                            <ul id="progressbar">
                                                <li id="account">Create Account</li>
                                                <li className="active" id="setupChat">Setup</li>
                                            </ul>
                                            <fieldset></fieldset>
                                            <fieldset>
                                                <div className="p-4">
                                                    <p className="activation_description"><strong>One last step
                                                        left!</strong>You can start the chat by adding the code to your
                                                        site.</p>
                                                </div>
                                                <div className="code_info">

                                                    <div className="code_area">
                                                        <div className="alert alert-warning alert-dismissible fade show"
                                                             role="alert">
                                                            Copy and paste this code before the closing <strong> {'< / body>'} </strong> tag on every page of your website.
                                                        </div>
                                                        <button
                                                            onClick={() => this.copyCodeToClipboard()}
                                                            className="copy_code chat-button chat-button-default">Copy
                                                        </button>
                                                        <textarea
                                                            ref={(textarea) => this.textArea = textarea}
                                                        >
                                                            {widgetCode(this.props.chatprop)}
                                                       </textarea>

                                                    </div>
                                                </div>
                                                <div className="later">
                                                    <button
                                                        disabled={this.state.loader}
                                                        onClick={() => this.completeSetup()}
                                                        className="chat-button completeSetup chat-button-success"
                                                        >
                                                        {this.state.loader === true &&
                                                        <div className="spinner-border" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                        }
                                                        {this.state.loader === false &&
                                                            <span>complete the installation<i className='bx bx-right-arrow-alt'></i></span>
                                                        }

                                                    </button>


                                                </div>
                                            </fieldset>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        );
    }
}

export default Installation;
